<template>
  <el-col :span="5">
    <b>
      {{ taskTypes[type] || '(нет данных)' }}<br />
      <loader-wrapper
        :loading="loadingAdmin"
        custom-class="cc-adm-item"
        spinner="el-icon-loading"
      >
        {{ shortFio(admin.fio) }}<br />
        {{ admin.login }}
      </loader-wrapper>
    </b>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex'
import { taskTypes } from '@/views/CallCenter/constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'TypeAndFio',
  components: { LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      taskTypes,
    }
  },
  computed: {
    ...mapGetters({
      getList: 'callCenter/getList',
      getLoading: 'callCenter/getLoading',
    }),
    admin() {
      return this.getList('admins', this.id) || {}
    },
    loadingAdmin() {
      return this.getLoading('Admin')
    },
  },
}
</script>

<style lang="sass">
.cc-item
  min-height: 80px
  background: #fff
  margin-top: 20px
  font-size: 14px
  padding: 15px 0
  .el-checkbox__label
    display: none
  .date
    font-size: 16px
    color: #8694A4
  .info
    p
      font-weight: bold
      margin: 0
      line-height: 24px
      &.red
        color: #ff0000
      &.green
        color: #2ecc71
    .ml-10
      padding-left: 10px
  .status
    height: 46px
    img
      width: 46px
  .btn-block
    display: flex
    align-items: center
    justify-content: center
    .call
      height: 40px
      padding: 0
      border: 0
      &:hover
        opacity: 0.7
      img
        width: 40px
  .cc-adm-item .el-loading-spinner
    margin-top: -8px
</style>
